<div class="aza-table-container">
    <ng-container *ngIf="(data$ | async) as data;">
        <ng-container *ngIf="rows.length || (!noDataElements?.length); else noDataTemplate">
            <div class="aza-table-table-view-container">
                <table class="aza-table-table-view">
                    <thead class="aza-table-table-view-header">
                        <tr class="aza-table-table-view-header-row">
                            <th *ngFor="let column of columns" class="aza-table-table-view-header-cell">
                                <span class="aza-table-table-view-header-cell-container">
                                    <div (click)="onColumnSorted(column)"
                                        class="aza-table-table-view-header-cell-text-and-icon-container">
                                        <span class="aza-table-table-view-header-cell-text">{{column.label}}</span>
                                        <div class="aza-table-table-view-header-cell-icon">
                                            <img src="assets/img/table/colored-sort-up.png">
                                            <img src="assets/img/table/colored-sort-down.png">
                                        </div>
                                    </div>
                                </span>
                            </th>
                            <th class="aza-table-table-view-header-cell aza-table-table-view-header-cell-action">
                                <ng-content select="[aza-table-action-header-cell-content]"></ng-content>
                            </th>
                        </tr>
                    </thead>
                    <tbody class="aza-table-table-view-body">
                        <ng-container *ngFor="let row of rows">
                            <tr class="aza-table-table-view-body-row {{rowClassNamesGetter?.(row.object).join(' ') || ''}}">
                                <td *ngFor="let cell of row.cells" class="aza-table-table-view-body-cell aza-table-table-view-body-cell__{{cell.field.name}}  aza-table-table-view-body-cell__value__{{cell.value}}">
                                    {{cell.text}}
                                </td>
                                <td class="aza-table-table-view-body-cell aza-table-table-view-body-cell-action">
                                    <ng-container *ngFor="let item of row.actionItems">
                                        <div *ngIf="!item.disabledFn?.(row)" (click)="onRowActionSelected(item, row, $event)"
                                            class="aza-table-table-view-body-cell-action-link-container aza-table-view-body-cell-action--{{replaceSpace(item.key, '-') | lowercase}} {{item.additionalClassNames || ''}}">
                                            <a href
                                                class="aza-table-table-view-body-cell-action-link aza-table-table-view-body-cell-action-link-text">{{item.label | translate}}</a>
                                        </div>
                                    </ng-container>

                                </td>
                            </tr>

                            <ng-container *ngIf="extraRowDivTemplate"
                                [ngTemplateOutlet]="extraRowDivTemplate"
                                [ngTemplateOutletContext]="{ row, isCardView: false }"
                            ></ng-container>
                        </ng-container>
                    </tbody>
                </table>
            </div>

            <div class="aza-table-card-view-container">
                <div class="aza-table-card-view-cards-container aza-vertical-stack">
                    <ng-content select="[aza-table-card-view-action-bar-content]"></ng-content>
                    <div *ngFor="let row of rows" (click)="onRowCardSelected(row, $event)"
                        class="aza-table-card-view-card-container {{rowClassNamesGetter?.(row.object).join(' ') || ''}}">
                        <ng-container *ngFor="let column of columns; let i = index;"
                            class="aza-table-card-view-card-line aza-horizontal-stack">
                            <div class="aza-table-card-view-card-row-field-label">{{column.label}}</div>
                            <div class="aza-table-card-view-card-row-field-value">{{row.cells[i].text}}</div>
                        </ng-container>
                        <ng-container *ngFor="let item of row.actionItems" >
                            <div *ngIf="!item.disabledFn?.(row)" (click)="onRowActionSelected(item, row, $event)"
                                class="aza-table-card-view-body-cell-action-link-container aza-table-view-body-cell-action--{{replaceSpace(item.label, '-') | lowercase}}">
                                <a href
                                    class="aza-table-card-view-body-cell-action-link aza-table-card-view-body-cell-action-link-text">{{item.label | translate}}</a>
                            </div>
                        </ng-container>
                        <div class="grid-item-column-span-2" *ngIf="extraRowDivTemplate">
                            <ng-container
                                [ngTemplateOutlet]="extraRowDivTemplate"
                                [ngTemplateOutletContext]="{ row, isCardView: true }"
                            ></ng-container>
                        </div>
                    </div>

                </div>
            </div>

            <div class="aza-table-pagination-container">
                <form [formGroup]="form" class="aza-table-pagination-page-size-container">
                    <ul class="aza-table-pagination-page-size-container">
                        <li class="aza-table-pagination-page-size-label" translate>ITEMS_PER_PAGE</li>
                        <li class="aza-table-pagination-page-size-value">
                            <select [formControl]="form.controls.itemsPerPage"
                                class="aza-table-pagination-page-size-selector">
                                <option [ngValue]="5">5</option>
                                <option [ngValue]="10">10</option>
                                <option [ngValue]="20">20</option>
                                <option [ngValue]="50">50</option>
                            </select>
                        </li>
                    </ul>
                </form>
                <ul class="aza-table-pagination-pages-container">
                    <div class="aza-table-pagination-pages-page-count">
                        <span translate
                            [translateParams]="{itemFrom: pagingData.itemFrom, itemTo: pagingData.itemTo, totalItems: pagingData.totalItems}">TABLE_PAGES_PAGE_COUNT</span>
                    </div>
                    <li class="aza-table-pagination-pages-button-container aza-table-pagination-pages-first-container">
                        <button (click)="onFirstPageRequested()" class="aza-table-pagination-pages-navigation-button">
                            <img src="assets/img/table/page-arrow-left-all.png"
                                class="aza-table-pagination-pages-navigation-button-image" />
                        </button>
                    </li>
                    <li class="aza-table-pagination-pages-button-container aza-table-pagination-pages-prev-container">
                        <button (click)="onPrevPageRequested()" class="aza-table-pagination-pages-navigation-button">
                            <img src="assets/img/table/page-arrow-left.png"
                                class="aza-table-pagination-pages-navigation-button-image" />
                        </button>
                    </li>
                    <li class="aza-table-pagination-pages-button-container aza-table-pagination-pages-next-container">
                        <button (click)="onNextPageRequested()" class="aza-table-pagination-pages-navigation-button">
                            <img src="assets/img/table/page-arrow-right.png"
                                class="aza-table-pagination-pages-navigation-button-image" />
                        </button>
                    </li>
                    <li class="aza-table-pagination-pages-button-container aza-table-pagination-pages-last-container">
                        <button (click)="onLastPageRequested()" class="aza-table-pagination-pages-navigation-button">
                            <img src="assets/img/table/page-arrow-right-all.png"
                                class="aza-table-pagination-pages-navigation-button-image" />
                        </button>
                    </li>
                </ul>
            </div>
        </ng-container>

    </ng-container>
    <ng-template #noDataTemplate>
        <ng-content select="[aza-rws-table-no-data-template]"></ng-content>
    </ng-template>
</div>
